// Categorical palette validated
const CATEGORY_PALETTE = [
  "#2a78d6", // blue
  "#1baf7a", // aqua
  "#eda100", // yellow
  "#008300", // green
  "#4a3aa7", // violet
  "#e34948", // red
  "#e87ba4", // magenta
  "#eb6834", // orange
];

// Categories beyond the 8-slot floor fold into a neutral "Other" color instead
// of generating a new hue (never cycle the categorical palette).
const OTHER_COLOR = "#78909c";

// Assigns a stable color per distinct category value: sorted alphabetically,
// slotted in fixed order. Re-parsing the same CSV always yields the same colors.
const assignCategoryColors = (values) => {
  const distinct = [...new Set(values.filter((v) => v != null && v !== ""))].sort();
  return distinct.reduce((colors, category, index) => {
    colors[category] = index < CATEGORY_PALETTE.length ? CATEGORY_PALETTE[index] : OTHER_COLOR;
    return colors;
  }, {});
};

export { CATEGORY_PALETTE, OTHER_COLOR, assignCategoryColors };
